export function validarToleranciaPreco(preco, precoTab, min, max){
    let menorPreco = precoTab * (min / 100) - precoTab;
    let maiorPreco = precoTab * (max / 100) + precoTab;
    if (preco >= menorPreco && preco <= maiorPreco){
        return true;
    } else {
        return false;
    }
}

export function validarQuantidadeCorte(qtdpcs, value){
    if(qtdpcs === 0 || qtdpcs > value){
        return true;
    }else {
        return false;
    }
}